import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import $ from "jquery";
import SideMenu from "../../Pages/SideMenu";
import Footer from "../../Pages/Footer";
import Header from "../../Pages/Header";
import Logout from "../../Pages/Logout";
import "@fortawesome/fontawesome-free/css/all.min.css";

//for data table
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
import "@fortawesome/fontawesome-svg-core/styles.css";

//for modal
import "bootstrap/dist/css/bootstrap.min.css";
import { productStatus, getMasters } from "../../Utilities/URLCONSTANTS";
import Loader from "../../Utilities/Loader";
import moment from "moment";
import * as XLSX from "xlsx";
import { GetApiHeaders } from "../../Utilities/NetworkUtilities";
import { customStyles, customstyles } from "../../Utilities/utils";
import Select from "react-select";
import {
  HiMiniArrowsUpDown,
  HiMiniArrowUp,
  HiMiniArrowDown,
} from "react-icons/hi2";
import Pagination from "../../Utilities/Pagination";

const ProductStatus = () => {
  const [loaderImage, setLoaderImage] = useState(
    require("../../images/cs_loader.gif")
  );
  const [submitResponse, setsubmitResponse] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showDetails, setShowDetails] = useState({});
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState();
  const [selectedItemIndex, setSelectedItemIndex] = useState();
  const [showWarningPopup, setShowWarningPopup] = useState(false);
  const [getData, setGetData] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10); // Default: 10 items per page
  const [searchTerm, setSearchTerm] = useState("");
  const [totalItems, setTotalItems] = useState();
  const [filteredData, setFilteredData] = useState([]);


  //for data table
  const tableRef = useRef(null);
  useEffect(() => {
    if ($.fn.DataTable.isDataTable(tableRef.current)) {
      $(tableRef.current).DataTable().destroy();
    }
    $(tableRef.current).DataTable({
      ordering: false,
    });
    fetchData();
    getMasterData();
  }, []);
  const handleModalClose = () => {
    setShowPopup(false);
    setShowModal(false);
    window.location.reload();
  };

  const locationFilteredData = filteredData.filter((item) => {
    return (
      selectedLocation === "" ||
      item.productStoreLocation === selectedLocation
    );
  });

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const handleItemsPerPageChange = (e) => {
    const selectedValue = parseInt(e.target.value);
    setItemsPerPage(selectedValue);
    setCurrentPage(1); // Reset to the first page when changing items per page.
  };

  const pageNumbers = [];
  //
  for (
    let i = Math.max(2, currentPage - 1);
    i <= Math.min(Math.ceil(totalItems / itemsPerPage) - 1, currentPage + 1);
    i++
  ) {
    // for (let i = 1; i <= Math.ceil(totalItems / itemsPerPage); i++) {
    pageNumbers.push(i);
  }

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const handleLocationChange = (event) => {
    setSelectedLocation(event.target.value);
  };
  const handleModalOpen = (item, index) => {
    setShowModal(true);
    setSelectedItem(item);
    setSelectedItemIndex(index);
  };
  const closeWarning = () => {
    setShowWarningPopup(true);
  };
  const handleClose = () => {
    setShowPopup(false);
    setShowModal(false);
    setShowWarningPopup(false);
  };

  // const fetchData = async () => {
  //   const GetApi = productStatus;
  //   const headers = await GetApiHeaders();
  //   try {
  //     setIsLoading(true);
  //     const response = await axios.post(GetApi, { headers });
  //     console.log("openStock", response);
  //     setData(response.data.response.openStock);
  //     setIsLoading(false);
  //   } catch (err) {
  //     console.log(err);
  //     setIsLoading(false);
  //   }
  // };

  const fetchData = async () => {
    const GetApi = productStatus;
    try {
      setIsLoading(true);
      const headers = await GetApiHeaders();
      const response = await axios.post(
        GetApi,
        {}, // request body
        { headers } // headers
      );
      console.log("openStock", response);
      if (response?.data?.response?.openStock) {
        setData(response.data.response.openStock);
      }
    } catch (err) {
      console.log("API Error:", err);
      // Handle server error response
      if (err.response) {
        console.log("Server Response:", err.response.data);
      }
    } finally {
      // Always stop loader
      setIsLoading(false);
    }
  };

  const getMasterData = async () => {
    const getData = getMasters;
    const headers = await GetApiHeaders();
    try {
      const responseGetData = await axios.post(getData, null, { headers });
      console.log("getmastrsssssss", responseGetData);
      setGetData(responseGetData.data.response.stockInwardLocations);
    } catch (err) {
      console.log("getError", err);
    }
  };

  const exportToExcel = () => {
    const data = [
      [
        "S.no",
        "Product Category",
        "Product Name",
        "Product store Location",
        "Unit Price",
        "Product Invoice No",
        "Manufacture Date",
        "Expiry Date",
      ], // Custom headers
      // ...currentItems.map((item) => [
      ...locationFilteredData.map((item, index) => [
        index + 1,
        item.productCategory,
        item.productName,
        item.productStoreLocation,
        item.unitPrice,
        item.productInvoiceNumber,
        item.productManufactureDate,
        item.productExpiryDate,
      ]),
    ];

    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");
    // Save the file
    XLSX.writeFile(wb, "productStatus.xlsx");
  };

  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const sortedData = [...locationFilteredData].sort((a, b) => {
    if (!sortConfig.key) return 0;

    const aValue = a[sortConfig.key];
    const bValue = b[sortConfig.key];

    // Numeric sort
    if (!isNaN(aValue) && !isNaN(bValue)) {
      return sortConfig.direction === "asc"
        ? Number(aValue) - Number(bValue)
        : Number(bValue) - Number(aValue);
    }

    // String sort
    const aString = (aValue ?? "").toString().toLowerCase();
    const bString = (bValue ?? "").toString().toLowerCase();

    if (aString < bString)
      return sortConfig.direction === "asc" ? -1 : 1;
    if (aString > bString)
      return sortConfig.direction === "asc" ? 1 : -1;

    return 0;
  });

  // Handle column sorting
  const handleSort = (key) => {
    setSortConfig((prevConfig) => ({
      key,
      direction: prevConfig.key === key && prevConfig.direction === "asc" ? "desc" : "asc",
    }));
  };

  const renderSortIcon = (key) => {
    if (sortConfig.key !== key) {
      return <HiMiniArrowsUpDown className="ms-1" size={16} />;
    }
    return sortConfig.direction === "asc" ? (
      <HiMiniArrowUp className="ms-1" size={16} />
    ) : (
      <HiMiniArrowDown className="ms-1" size={16} />
    );
  };

  useEffect(() => {
    if (data && data.length > 0) {
      setFilteredData(data); // Initialize with full data
      setTotalItems(data.length); // Set total items
    }
  }, [data]);

  const locationOptions =
    getData?.map((item) => ({
      value: item.name,
      label: item.name,
    })) || [];
   
  const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);
  return (
    <body id="page-top">
      {/*  <!-- Page Wrapper --> */}
      <div id="wrapper">
        {/*  <!-- Sidebar --> */}
        <SideMenu />
        {/*  <!-- End of Sidebar --> */}

        {/*  <!-- Content Wrapper --> */}
        <div id="content-wrapper" className="d-flex flex-column">
          {/*  <!-- Main Content --> */}
          <div id="content">
            {/*  <!-- Topbar --> */}
            <Header />
            {/* ...Content Start... */}
            <div>
              <div className="container-fluid">
                <h5 className="Roles_text">Central Store</h5>

                <div>
                  <h5 className="mb-0 Sub_role_text"> Product Status </h5>
                </div>
                <div>
                  <span style={{ color: "red", fontSize: 14 }}>
                    Below displayed products list is expiring within 30 days.
                  </span>
                </div>
                <div className="card border-0">
                  <div className="card-body pt-0 pl-1">
                    <div className="d-flex justify-content-between"></div>
                    <div
                      className="d-flex justify-content-between align-items-center"
                      style={{ paddingBottom: 20 }}
                    >
                      <div className="d-flex align-items-center">
                        <label className="mr-1">Show </label>
                        <Select
                          options={[
                            { value: 10, label: '10' },
                            { value: 20, label: '20' },
                            { value: 50, label: '50' },
                          ]}
                          value={{
                            value: itemsPerPage,
                            label: String(itemsPerPage),
                          }}
                          onChange={(selected) => {
                            setItemsPerPage(selected.value);
                            setCurrentPage(1);
                          }}
                          isSearchable={false}
                          styles={customstyles}
                        />

                        &nbsp;
                        <label> Entries</label>
                      </div>
                      <div className="d-flex align-items-center">
                        {/* Search Input */}
                        <Select
                          className="mb-2"
                          styles={customStyles}
                          options={locationOptions}
                          placeholder="Select Location"
                          value={
                            locationOptions.find(
                              (option) => option.value === selectedLocation
                            ) || null
                          }
                          onChange={(selectedOption) =>
                            setSelectedLocation(selectedOption?.value || "")
                          }
                        />
                        &nbsp;
                        <div className="my-2 d-flex w-full justify-content-end gap-2">
                          <button
                            className="btn btn-secondary  buttons-html5 "
                            onClick={exportToExcel}
                          >
                            Download Excel
                          </button>

                        </div>
                      </div>
                    </div>
                    <div>
                      <div
                        className="card data_tableCard mr-2 ml-1"
                        // style={{ width: "100%", overflowX: "auto" }}
                        style={{ width: "100%" }}
                      >
                        <div className="card-body ">
                          {/* <div style={{ width: "100%", overflowX: "auto" }}> */}
                          <Table className="table table-bordered table-bg Content_data_table table-striped">
                            <Thead>
                              <Tr>
                                <Th className="text-center">S.No</Th>
                                <Th
                                  className="text-center cursor-pointer"
                                  onClick={() => handleSort("productCategory")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Item Category
                                    {renderSortIcon("productCategory")}
                                  </span>
                                </Th>
                                <Th
                                  className="text-center cursor-pointer"
                                  onClick={() => handleSort("productName")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Item Name
                                    {renderSortIcon("productName")}
                                  </span>
                                </Th>
                                <Th
                                  className="text-center cursor-pointer"
                                  onClick={() => handleSort("productStoreLocation")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Store Location
                                    {renderSortIcon("productStoreLocation")}
                                  </span>
                                </Th>
                                <Th
                                  className="text-center cursor-pointer"
                                  onClick={() => handleSort("unitPrice")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Unit Size
                                    {renderSortIcon("unitPrice")}
                                  </span>
                                </Th>
                                <Th
                                  className="text-center cursor-pointer"
                                  onClick={() => handleSort("productManufactureDate")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    MFG Date
                                    {renderSortIcon("productManufactureDate")}
                                  </span>
                                </Th>
                                <Th
                                  className="text-center cursor-pointer"
                                  onClick={() => handleSort("productExpiryDate")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Expiry Date
                                    {renderSortIcon("productExpiryDate")}
                                  </span>
                                </Th>
                                <Th
                                  className="text-center cursor-pointer"
                                  onClick={() => handleSort("productInvoiceNumber")}
                                >
                                  <span className="d-inline-flex align-items-center">
                                    Invoice No
                                    {renderSortIcon("productInvoiceNumber")}
                                  </span>
                                </Th>
                              </Tr>
                            </Thead>
                            <Tbody>
                              {/* {filteredData.length === 0 ? ( */}
                              {currentItems.length === 0 ? (
                                <Tr>
                                  <Td colSpan={13} className="text-center">
                                    Data is not available
                                  </Td>
                                </Tr>
                              ) : (
                                // filteredData.map((item, index) => {
                                currentItems.map((item, index) => {
                                  var newDateFormat = moment(
                                    item.productManufactureDate
                                  ).format("DD-MMM-YYYY ");
                                  var ExpiryDAte = moment(
                                    item.productExpiryDate
                                  ).format("DD-MMM-YYYY ");
                                  return (
                                    <Tr key={index}>
                                      <Td className="text-left">{(currentPage - 1) * itemsPerPage + index + 1}</Td>
                                      <Td className="text-left">
                                        {item.productCategory}
                                      </Td>

                                      <Td className="text-left">
                                        {item.productName}
                                      </Td>
                                      <Td className="text-left">
                                        {item.productStoreLocation}
                                      </Td>
                                      <Td className="text-right">
                                        {item.unitPrice}
                                      </Td>

                                      <Td className="text-center">
                                        {newDateFormat}{" "}
                                      </Td>
                                      <Td
                                        className="text-center"
                                        style={{ color: "red" }}
                                      >
                                        {ExpiryDAte}{" "}
                                      </Td>
                                      <Td className="text-center">
                                        {item.productInvoiceNumber}
                                      </Td>
                                    </Tr>
                                  );
                                })
                              )}
                            </Tbody>
                          </Table>
                        </div>
                        <Pagination
                          currentPage={currentPage}
                          totalItems={sortedData.length}
                          itemsPerPage={itemsPerPage}
                          currentItems={currentItems}
                          onPageChange={handlePageClick}
                        />
                        {/* </div> */}
                        {isLoading && (
                          <Loader
                            loading={isLoading}
                            message={"Fetching Data. Please Wait..!"}
                            loderimage={loaderImage}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                  {loading && (
                    <div>
                      <p>Fetching data. Please wait...</p>
                      <Loader
                        height="80"
                        width="80"
                        radius="9"
                        color="#4A7729"
                        ariaLabel="loading"
                      />
                    </div>
                  )}
                </div>
              </div>
              {/* </div> */}
              {/* Pagination */}
              {/* <Pagination
              currentPage={currentPage}
              totalItems={sortedData.length}
              itemsPerPage={itemsPerPage}
              currentItems={currentItems}
              onPageChange={handlePageClick}
            /> */}
            </div>
          </div>
          {/* ...End of Main Content...*/}
          {/* ...Footer...*/}
          <Footer />
          {/* ... End of Footer...  */}
        </div>
      </div>
      {/*  <!-- End of Page Wrapper -->
      <!-- Scroll to Top Button--> */}
      <a className="scroll-to-top rounded" href="#page-top">
        <i className="fas fa-angle-up"></i>
      </a>
      {/*  <!-- Logout Modal--> */}
      <Logout />
    </body>
  );
};
export default ProductStatus;
